<template>
    <b-container fluid >
        <section-contacto-principal :content="section_contacto"/>
    </b-container>
</template>
<script>
    import SectionContactoPrincipal from '@/components/section-contacto-principal'

    export default {
        name: 'Contacto',
        components: {
            SectionContactoPrincipal
        },
        data: () => ({
            section_contacto : {
                content: 'Completa este formulario para recibir asesoría a la medida de tu negocio.'
            }
        }),
        methods: {}
    }
</script>
<style scoped>
</style>